import * as actionTypes from "../actionTypes";
import axios from "axios";
import { config } from "../../../config/config";

const fetchCustomersStart = () => {
  return {
    type: actionTypes.FETCH_CUSTOMERS_START,
  };
};

const fetchCustomersSuccess = (customers, total) => {
  return {
    customers,
    total,
    type: actionTypes.FETCH_CUSTOMERS_SUCCESS,
  };
};

const fetchCustomersFailed = (err) => {
  return {
    err,
    type: actionTypes.FETCH_CUSTOMERS_FAILED,
  };
};

export const onFetchCustomers = (page, limit, params) => {
  return async (dispatch) => {
    await dispatch(fetchCustomersStart());

    try {
      let url = `${config.users}?limit=${limit}&page=${page + 1}`;
      if (params) {
        url += `&${params}`;
      }

      const customers = await axios.get(url);
      await dispatch(
        fetchCustomersSuccess(
          customers.data,
          customers.headers["x-total-count"]
        )
      );
    } catch (e) {
      await dispatch(fetchCustomersFailed());
    }
  };
};

// FILTER
export const onFilterCustomers = () => {
  return {
    type: actionTypes.FILTER_CUSTOMERS_SUCCESS,
  };
};

const filterCustomersResetStart = () => {
  return {
    type: actionTypes.FILTER_CUSTOMERS_RESET,
  };
};

export const onFilterCustomersReset = () => {
  return async (dispatch) => {
    await dispatch(filterCustomersResetStart());
    await dispatch(onFetchCustomers(0, 20));
  };
};

// CUSTOMER
const fetchCustomerStart = () => {
  return {
    type: actionTypes.FETCH_CUSTOMER_START,
  };
};

const fetchCustomerSuccess = (customer) => {
  return {
    customer,
    type: actionTypes.FETCH_CUSTOMER_SUCCESS,
  };
};

const fetchCustomerFailed = (err) => {
  return {
    err,
    type: actionTypes.FETCH_CUSTOMER_FAILED,
  };
};

export const onFetchCustomer = (id) => {
  return async (dispatch) => {
    await dispatch(fetchCustomerStart());

    try {
      const customer = await axios.get(`${config.users}?id=${id}`);
      await dispatch(fetchCustomerSuccess(customer.data));
    } catch (err) {
      await dispatch(fetchCustomerFailed());
    }
  };
};
